import { styled } from "@mui/material/styles";
import { Button, Tab } from "@mui/material";
export const StyledButton = styled(Button)(({ theme }) => ({
  color: `#fff !important`,
  backgroundColor: theme.palette.secondary.main,
  minWidth: '88px',
  borderRadius: '2px',
  textTransform: 'capitalize',
  fontSize: '14px',
  fontWeight: 600,
  boxShadow: '0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12)',
  '&.Mui-disabled': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : '#a5a5a5',
    color: '#fff !important',
    boxShadow: 'none',
  },
}));
export const StyledCancelButton = styled(Button)(({ theme }) => ({
  color: theme.palette.mode === 'dark' ? `#ffffff !important` : `#000000DE !important`,
  border: theme.palette.mode === 'dark' ? '1px solid rgba(255, 255, 255, 0.4)' : '1px solid #616161',
  minWidth: '88px',
  borderRadius: '2px',
  textTransform: 'none',
  fontSize: '14px',
  fontWeight: 600,
}));
export const StyledBlueButton = styled(Button)(({ theme }) => ({
  color: `#fff !important`,
  backgroundColor: theme.palette.mode === 'dark' ? '#3c50b4' : theme.palette.primary.main,
  minWidth: '88px',
  borderRadius: '2px',
  textTransform: 'capitalize',
  fontSize: '14px',
  fontWeight: 600,
  boxShadow: '0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12)',
  '&.Mui-disabled': {
    color: "#00000061",
    backgroundColor: "#0000001F",
    boxShadow: 'none',
  },
}));
export const StyledGreenButton = styled(Button)(({ theme }) => ({
  color: `#fff !important`,
  backgroundColor: theme.palette.secondary.main,
  minWidth: '88px',
  borderRadius: '2px',
  textTransform: 'capitalize',
  fontSize: '14px',
  fontWeight: 600,
  boxShadow: '0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12)',
  '&.Mui-disabled': {
    color: "#00000061",
    backgroundColor: "#0000001F",
    boxShadow: 'none',
  },
}));
export const StyledTab = styled(Tab)(({ theme, value }) => ({
  fontSize: 15,
  fontWeight: 600,
  textTransform: 'none',
  // borderBottom: value === 0 ? "2px solid #3f51b5" : "2px solid #A9ABB5",
}));
export const Textarea = styled('textarea')(({ theme }) => ({
  border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.4)' : '#616161'}`,
  padding: '8px',
  borderRadius: '8px',
  backgroundColor: theme.palette.mode === 'dark' ? '#040406 !important' : '#f4f4f4 !important',
  color: theme.palette.mode === 'dark' ? '#ffffff !important' : 'inherit !important',
  outline: 'none',
  fontFamily: 'inherit',
  fontSize: 'inherit',
  width: '100%',
  '&:focus': {
    borderColor: theme.palette.primary.main,
  }
}));